/**
 *
 * DimensionBox
 *
 */

import React, { Component } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
import { Switch, Tooltip, Popover, Button, Tag } from "antd"
import { truncate } from "lodash"
import threePoints from "../../images/three-points.svg"
import threePointsGray from "../../images/three-points-gray.svg"
import questionIcon from "../../images/question.svg"
import { validate } from "../../utils/functions"
import { ThreePointsIcon } from "../../icons/svg/iconThreePoints"
import { buttonAction_btns, buttonAction_context } from "../Snowplow/config2"

class SwitchRender extends Component {
  state = { isLoadingSubquestion: false }

  render() {
    return (
      <Switch
        disabled={this.props.disabled}
        loading={this.state.isLoadingSubquestion}
        checked={this.props.checked}
        onChange={(e) => {
          this.setState({ isLoadingSubquestion: true })
          if (this.props.item) {
            const params = {
              idQuestion: this.props.item.question_id_question_has_dimensions,
              params: {
                enabled: e ? 1 : 0,
                id_dimension_has_survey: this.props.id_dimension,
              },
            }

            setTimeout(
              () => this.setState({ isLoadingSubquestion: false }),
              1800
            )
            this.props.updateQuestionDimensionWatcher(params)
          } else {
            const params = {
              idDimension: this.props.id_dimension,
              params: {
                enabled: e ? 1 : 0,
              },
            }

            setTimeout(
              () => this.setState({ isLoadingSubquestion: false }),
              1800
            )
            this.props.updateDimensionWatcher(params)
          }
        }}
      />
    )
  }
}

const SubDivision = (
  subdivision,
  showOptions,
  toggleDrawer,
  updateQuestionDimensionWatcher,
  updateDimensionWatcher,
  getQuestionWatcher,
  getDimensionWatcher,
  getQuestionTypesWatcher,
  id_survey,
  hideTag,
  measures,
  isSurveyMandu,
  idDimension,
  index,
  item
) => {
  const contentMeditions = (item) => (
    <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
      <p>
        Esta pregunta afecta a{" "}
        <b>{item.multidimensions && item.multidimensions.length}</b>{" "}
        dimensiones:{" "}
      </p>
      <ul style={{ marginLeft: 15 }}>
        {item.multidimensions &&
          item.multidimensions.map((md, mdi) => <li key={mdi}>{md}</li>)}
      </ul>

      <p>
        ¡Pero no te preocupes! La pregunta <b>aparecerá una única vez</b> en el
        cuestionario que el colaborador deberá contestar.
      </p>
    </div>
  )
  const isEngagement = item.dimension_name ?  item.dimension_name.toLowerCase() === "engagement":false
  return (
    <div className="dimension-box-subdivision" key={index}>
      <div className="subdivision-li">
        <span className="subdivision-li-title">
          {subdivision.dimension_title}
        </span>
        <div className="subdivision-li-actions">
          {validate.exist(measures) && (
            <SwitchRender
              updateDimensionWatcher={updateDimensionWatcher}
              id_dimension={ isEngagement?item.dimension_id_dimension_has_survey:subdivision.dimension_id_dimension_has_survey}
              disabled={!!measures.length}
              checked={subdivision.dimension_enabled}
              item={isEngagement?subdivision:false}
              updateQuestionDimensionWatcher={updateQuestionDimensionWatcher}
              isEngagement={isEngagement}
            />
          )}
          {validate.exist(measures) &&
          item.dimension_name.toLowerCase() !== "engagement" ? (
            <Tooltip placement="top" title="Editar subdimensión">
              <div
                className="dbox-dots"
                onClick={() => {
                  if (!subdivision.dimension_enabled) return

                  getDimensionWatcher(
                    subdivision.dimension_id_dimension_has_survey
                  )
                  toggleDrawer("subdimensionDrawer", true)
                  window.Intercom('update', { hide_default_launcher: true})
                  Intercom("close")
                }}>
                <img
                  src={
                    subdivision.dimension_enabled
                      ? threePoints
                      : threePointsGray
                  }
                />
              </div>
            </Tooltip>
          ) : (
            <div style={{ width: 35 }} />
          )}
        </div>
      </div>

      <ul className="questions-ul">
        {subdivision.questions.map((item, index) => {
          return (
            <li
              key={index}
              style={{ color: item.question_enabled ? "" : "#C4C4C4" }}>
              <div className="questions-li">
                <span
                  className="questions-li-title"
                  style={{ color: item.question_enabled ? "" : "#C4C4C4" }}>
                  {truncate(item.question_name, { length: 128 }) }
                  {item.required && (<span className='required'>*</span>)}
                  {!item.required && <Tag color="default" className="tagQuestion">Opcional</Tag>}
                  {item.multidimensions && item.multidimensions.length > 0 && (
                    <Popover
                      placement="bottom"
                      content={contentMeditions(item)}>
                      <div className="type type-gray">
                        x{item.multidimensions && item.multidimensions.length}
                      </div>
                    </Popover>
                  )}

                  {!hideTag && isSurveyMandu && !item.question_generic && (
                    <div className="type type-yellow">
                      <span>Pregunta personalizada</span>
                    </div>
                  )}
                </span>
                {showOptions && (
                  <div className="questions-li-actions">
                    <SwitchRender
                      id_dimension={idDimension}
                      disabled={!!measures.length}
                      checked={item.question_enabled}
                      item={item}
                      updateDimensionWatcher={updateDimensionWatcher}
                      updateQuestionDimensionWatcher={
                        updateQuestionDimensionWatcher
                      }
                      isEngagement={isEngagement}
                    />
                    {/* <Tooltip placement="top" title="Editar preguntas">
                      <div
                        className="dbox-dots"
                        onClick={() => {
                          if (!item.question_enabled) return
                          getQuestionTypesWatcher(id_survey)
                          getQuestionWatcher(item.question_id_question)
                          toggleDrawer("questionsDrawer", true)
                        }}>
                        <img
                          src={
                            item.question_enabled
                              ? threePoints
                              : threePointsGray
                          }
                        />
                      </div>
                    </Tooltip> */}
                    <Tooltip placement="top" title="Editar preguntas">
                      <Button
                        type="link"
                        className="QuestionDrawer__button--edit"
                        onClick={() => {
                          if (!item.question_enabled) return
                          getQuestionTypesWatcher(id_survey)
                          getQuestionWatcher(item.question_id_question)
                          toggleDrawer("questionsDrawer", true)
                          window.Intercom('update', { hide_default_launcher: true})
                          Intercom("close")
                          buttonAction_context("Editar preguntas de cuestionario",'id_survey',id_survey)
                        }}
                        icon={
                          <ThreePointsIcon
                            style={{
                              color: item.question_enabled
                                ? "#378FEE"
                                : "#C4C4C4",
                            }}
                          />
                        }
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
              <div className="segments">
                {item.question_segments !== undefined && (
                  item.question_segments.map((d, di) => (
                    <span className="span-segments"> <b>- {d.segment}:</b> {d.name}</span>
                  ))
                )}
              </div>

            </li>
          )
        })}
      </ul>
    </div>
  )
}
class DimensionBox extends React.Component {
  state = {
    isLoadingSurvey: false,
    isLoadingQuestion: false,
  }

  render() {
    const { item, hideDescripion } = this.props
    const contentEngagement = (
      <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
        Las preguntas de <span style={{ fontWeight: 600 }}>Engagement</span>{" "}
        permiten medir directamente el nivel de compromiso de los colaboradores
        con la organización. Por ello, su resultado no es considerado para el
        Clima Laboral, sino que se calcula de manera separada para obtener el
        nivel de Engagement como un indicador independiente.
      </div>
    )
    const contentMeditions = (item) => (
      <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
        <p>
          Esta pregunta afecta a{" "}
          <b>{item.multidimensions && item.multidimensions.length}</b>{" "}
          dimensiones:{" "}
        </p>
        <ul style={{ marginLeft: 15 }}>
          {item.multidimensions &&
            item.multidimensions.map((md, mdi) => <li key={mdi}>{md}</li>)}
        </ul>

        <p>
          ¡Pero no te preocupes! La pregunta <b>aparecerá una única vez</b> en
          el cuestionario que el colaborador deberá contestar.
        </p>
      </div>
    )
    const isEngagement = item.dimension_title.toLowerCase() === "engagement";

    return (
      <div className="dimension-box">
        <div className="dimension-box-header">
          <div className="dimension-box-division">
            <div className="dimension-box-division-left">
              {item.dimension_icon_image && (
                <img src={item.dimension_icon_image} />
              )}
              <div className="dimension-box-division-titleBox">
                <span className="dimension-box-division-titleDefault">
                  {item.dimension_title}
                  {isEngagement && (
                    <Popover placement="rightTop" content={contentEngagement}>
                      <img src={questionIcon} style={{ marginLeft: 8 }} />
                    </Popover>
                  )}
                </span>
                {!hideDescripion && (
                  <span className="dimension-box-division-subTitleDefault">
                    {item.dimension_description || ""}
                  </span>
                )}
              </div>
            </div>
            <div className="dimension-box-division-right">
              {this.props.showOptions && (
                <React.Fragment>
                  <Switch
                    disabled={!!this.props.measures.length}
                    loading={this.state.isLoadingSurvey}
                    checked={item.dimension_enabled}
                    onChange={(e) => {
                      this.setState({ isLoadingSurvey: true })
                      const params = {
                        idDimension: item.dimension_id_dimension_has_survey,
                        // params: `?enabled=${e ? 1 : 0}`
                        params: { enabled: e ? 1 : 0 },
                      }
                      setTimeout(() => {
                        this.setState({ isLoadingSurvey: false })
                      }, 1500)
                      this.props.updateDimensionWatcher(params)
                    }}
                  />
                  {isEngagement ? (
                    <div style={{ width: 35 }} />
                  ) : (
                    <Tooltip placement="top" title="Editar dimensión">
                      <div
                        className="dbox-dots"
                        onClick={() => {
                          if (!item.dimension_enabled) return

                          this.props.getDimensionWatcher(
                            item.dimension_id_dimension_has_survey
                          )
                          this.props.toggleDrawer("dimensionDrawer", true)
                          window.Intercom('update', { hide_default_launcher: true})
                          Intercom("close")
                        }}>
                        <img
                          src={
                            item.dimension_enabled
                              ? threePoints
                              : threePointsGray
                          }
                        />
                      </div>
                    </Tooltip>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
          {!!item.questions.length && (
            <ul className="questions-ul">
              {item.questions.map((itemQuestion, index) => {
                return (
                  <li
                    key={index}
                    style={{
                      color: itemQuestion.question_enabled ? "" : "#C4C4C4",
                      marginBottom:10
                    }}>
                    <div className="questions-li">
                      <span
                        className="questions-li-title"
                        style={{
                          color: itemQuestion.question_enabled ? "" : "#C4C4C4",
                        }}>
                        {truncate(itemQuestion.question_name, { length: 128 })}
                        {itemQuestion.required && (<span className='required'>*</span>)}
                        {!itemQuestion.required && <Tag color="default" className="tagQuestion">Opcional</Tag>}
                        {itemQuestion.multidimensions.length > 0 && (
                          <Popover
                            placement="bottom"
                            content={contentMeditions(itemQuestion)}>
                            <div className="type type-gray">
                              x{itemQuestion.multidimensions.length}
                            </div>
                          </Popover>
                        )}
                        {!this.props.hideTag &&
                          this.props.isSurveyMandu &&
                          !itemQuestion.question_generic && (
                            <div className="type type-yellow">
                              <span>Pregunta personalizada</span>
                            </div>
                          )}
                      </span>
                      <div className="questions-li-actions">
                        {this.props.showOptions && (
                          <React.Fragment>
                            <SwitchRender
                              id_dimension={
                                item.dimension_id_dimension_has_survey
                              }
                              disabled={!!this.props.measures.length}
                              checked={itemQuestion.question_enabled}
                              item={itemQuestion}
                              updateDimensionWatcher={
                                this.props.updateDimensionWatcher
                              }
                              updateQuestionDimensionWatcher={
                                this.props.updateQuestionDimensionWatcher
                              }
                              isEngagement={isEngagement}
                            />
                            <Tooltip placement="top" title="Editar preguntas">
                              <div
                                className="dbox-dots"
                                onClick={() => {
                                  if (!itemQuestion.question_enabled) return
                                  this.props.getQuestionTypesWatcher(
                                    this.props.idSurvey
                                  )
                                  this.props.getQuestionWatcher(
                                    itemQuestion.question_id_question
                                  )
                                  this.props.toggleDrawer(
                                    "questionsDrawer",
                                    true
                                  )
                                  window.Intercom('update', { hide_default_launcher: true})
                                  Intercom("close")
                                  buttonAction_btns(
                                    "Editar preguntas de cuestionario"
                                  )
                                }}>
                                <img
                                  src={
                                    itemQuestion.question_enabled
                                      ? threePoints
                                      : threePointsGray
                                  }
                                />
                              </div>
                            </Tooltip>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                    {itemQuestion.question_segments !== undefined && (
                      <div className="segments">
                        {itemQuestion.question_segments.map((d, di) => (
                          <span className="span-segments"> <b>- {d.segment}:</b> {d.name}</span>
                        ))}
                      </div>)
                    }
                  </li>
                )
              })}
            </ul>
          )}
        </div>
        {item.subdimensions.map((subdivision, index) =>
          SubDivision(
            subdivision,
            this.props.showOptions,
            this.props.toggleDrawer,
            this.props.updateQuestionDimensionWatcher,
            this.props.updateDimensionWatcher,
            this.props.getQuestionWatcher,
            this.props.getDimensionWatcher,
            this.props.getQuestionTypesWatcher,
            this.props.idSurvey,
            this.props.hideTag,
            this.props.measures,
            this.props.isSurveyMandu,
            item.dimension_id_dimension_has_survey,
            index,
            item
          )
        )}
      </div>
    )
  }
}

DimensionBox.propTypes = {}

export default DimensionBox
